// Marketing consent form handling
document.addEventListener('DOMContentLoaded', function() {
    const marketingForm = document.querySelector('.marketing-form');
    
    if (marketingForm) {
        marketingForm.addEventListener('submit', function(e) {
            // Non prevenire il submit, lascia che Shopify gestisca tutto
            // Aggiungi solo un feedback visivo
            const submitBtn = this.querySelector('.account-submit-btn');
            if (submitBtn) {
                submitBtn.textContent = 'Aggiornamento...';
                submitBtn.disabled = true;
            }
        });
    }
});

// Password reset functionality
document.addEventListener('DOMContentLoaded', function() {
    const passwordResetLink = document.querySelector('.password-reset-link');
    const passwordSection = document.querySelector('.password-section');
    
    if (passwordResetLink && passwordSection) {
        passwordResetLink.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Controlla se i campi password sono già visibili
            const existingFields = passwordSection.querySelector('.password-fields');
            
            if (existingFields) {
                // Se i campi esistono già, mostra/nascondi
                existingFields.style.display = existingFields.style.display === 'none' ? 'block' : 'none';
            } else {
                // Crea i campi password
                const passwordFields = document.createElement('div');
                passwordFields.className = 'password-fields';
                passwordFields.innerHTML = `
                    <div class="account-form-group">
                        <label for="current-password">Password attuale</label>
                        <input type="password" id="current-password" name="customer[password]" required>
                    </div>
                    <div class="account-form-group">
                        <label for="new-password">Conferma nuova password</label>
                        <input type="password" id="new-password" name="customer[password]" required>
                    </div>
                `;
                
                // Aggiungi i campi al container del form
                const passwordContainer = document.getElementById('password-fields-container');
                if (passwordContainer) {
                    passwordContainer.appendChild(passwordFields);
                }
            }
        });
    }
    
    function handlePasswordUpdate() {
        const currentPassword = document.getElementById('current-password').value;
        const newPassword = document.getElementById('new-password').value;
        const confirmPassword = document.getElementById('confirm-password').value;
        
        // Validazione
        if (!currentPassword || !newPassword || !confirmPassword) {
            alert('Tutti i campi sono obbligatori');
            return;
        }
        
        if (newPassword !== confirmPassword) {
            alert('Le password non coincidono');
            return;
        }
        
        if (newPassword.length < 6) {
            alert('La nuova password deve essere di almeno 6 caratteri');
            return;
        }
        
        // Qui puoi aggiungere la logica per inviare i dati al server
        // Per ora mostriamo solo un messaggio di successo
        alert('Password aggiornata con successo!');
        
        // Nascondi i campi dopo il successo
        const passwordFields = document.querySelector('.password-fields');
        if (passwordFields) {
            passwordFields.style.display = 'none';
        }
    }
});

// ... existing code ...
document.addEventListener('DOMContentLoaded', function() {
    // Funzione per inizializzare gli swatch
    function initSwatches() {

        // Seleziona tutti gli elementi con il data attribute per gli swatch
        const swatchButtons = document.querySelectorAll('[data-variant-swatch]');

        swatchButtons.forEach(button => {
            // Rimuovi eventuali listener precedenti per evitare duplicazioni
            button.removeEventListener('click', handleSwatchClick);
            // Aggiungi il nuovo listener
            button.addEventListener('click', handleSwatchClick);
        });
    }

    // Funzione di gestione del click su uno swatch
    function handleSwatchClick(event) {
        event.preventDefault();

        // Trova la card del prodotto parente
        const productCard = this.closest('.product-card');
        if (!productCard) {
            return;
        }

        // Rimuovi la classe selected da tutti gli swatch in questa card
        const allSwatches = productCard.querySelectorAll('[data-variant-swatch]');

        allSwatches.forEach(swatch => {
            if (swatch.classList.contains('selected')) {
                swatch.classList.remove('selected');
            }
        });

        // Aggiungi la classe selected a questo swatch
        this.classList.add('selected');

        // Aggiorna l'immagine del prodotto
        updateProductImage(this, productCard);
    }

    // Funzione per aggiornare l'immagine del prodotto
    function updateProductImage(swatch, productCard) {
        const variantImageUrl = swatch.getAttribute('data-variant-image');
        if (!variantImageUrl) {
            return;
        }

        const productImage = productCard.querySelector('.product-card__media img');
        if (!productImage) {
            return;
        }

        productImage.src = variantImageUrl;

        if (productImage.hasAttribute('srcset')) {
            productImage.srcset = `${variantImageUrl} ${productImage.width}w`;
        }
    }

    // Inizializza gli swatch
    initSwatches();

    // In caso di aggiornamenti dinamici al DOM (come con AJAX)
    document.addEventListener('shopify:section:load', initSwatches);
});

(function() {
    // Stato globale e contatori
    const state = {
        initCounter: 0,            // Conta le inizializzazioni
        MAX_INITS: 15,             // Limite massimo di inizializzazioni per sessione
        lastInitTime: 0,           // Timestamp dell'ultima inizializzazione
        MIN_INIT_INTERVAL: 1000,   // Intervallo minimo tra inizializzazioni (ms)
        initializing: false,       // Flag di inizializzazione in corso
        initialized: new Set(),    // Set di ID card già inizializzate
        debug: true                // Modalità debug
    };

    // Protezione contro inizializzazioni eccessive
    function canInitialize(force = false) {
        // Se è una inizializzazione forzata, incrementa comunque il contatore
        if (force) {
            state.initCounter++;
        }

        // Se stiamo già inizializzando, blocca
        if (state.initializing) {
            return false;
        }

        // Controlla il contatore globale
        if (state.initCounter >= state.MAX_INITS) {
            return false;
        }

        // Controlla l'intervallo minimo
        const now = Date.now();
        if (now - state.lastInitTime < state.MIN_INIT_INTERVAL && !force) {
            return false;
        }

        // Aggiorna lo stato
        state.initCounter++;
        state.lastInitTime = now;
        state.initializing = true;

        return true;
    }

    // Funzione principale per inizializzare gli swatch
    function initSwatchHandlers(force = false) {
        // Verifica se possiamo inizializzare
        if (!canInitialize(force)) {
            return;
        }

        try {
            // Rendi tutte le card visibili prima dell'inizializzazione
            makeAllProductCardsVisible();

            // Trova tutte le card di prodotto
            const productCards = document.querySelectorAll('.product-card');

            if (productCards.length === 0) return;

            // Assegna ID alle card se non ne hanno
            productCards.forEach(card => {
                if (!card.dataset.swatchId) {
                    card.dataset.swatchId = 'card-' + Math.random().toString(36).substr(2, 9);
                }
            });

            // Inizializza solo le card che hanno bisogno di inizializzazione
            let initializedCount = 0;

            productCards.forEach(card => {
                // Salta le card già inizializzate in questa sessione (a meno che non sia forzato)
                if (!force && state.initialized.has(card.dataset.swatchId)) {
                    return;
                }

                // Trova gli swatch nella card
                const swatches = card.querySelectorAll('[data-variant-swatch]');
                if (swatches.length === 0) return;

                // Se la card ha già uno swatch selezionato e non è forzato, aggiorna solo lo stato del bottone
                const selectedSwatch = card.querySelector('[data-variant-swatch].selected');
                if (selectedSwatch && !force) {
                    const isAvailable = selectedSwatch.getAttribute('data-variant-available') === 'true';
                    updateButtonState(card, isAvailable);
                    state.initialized.add(card.dataset.swatchId);
                    initializedCount++;
                    return;
                }

                // Rimuovi gli event listener esistenti ricreando gli elementi
                const freshSwatches = [];
                swatches.forEach(swatch => {
                    const newSwatch = swatch.cloneNode(true);
                    swatch.parentNode.replaceChild(newSwatch, swatch);
                    freshSwatches.push(newSwatch);
                });

                // Aggiungi handler di click ai nuovi swatch
                freshSwatches.forEach(swatch => {
                    swatch.addEventListener('click', handleSwatchClick);
                });

                // Se già esiste uno swatch selezionato, usalo
                const newSelectedSwatch = card.querySelector('[data-variant-swatch].selected');

                // Altrimenti trova il primo disponibile
                let swatchToSelect = newSelectedSwatch;
                if (!swatchToSelect) {
                    // Cerca prima uno swatch disponibile
                    swatchToSelect = freshSwatches.find(s => s.getAttribute('data-variant-available') === 'true');

                    // Se non c'è, usa il primo
                    if (!swatchToSelect && freshSwatches.length > 0) {
                        swatchToSelect = freshSwatches[0];
                    }

                    // Seleziona lo swatch
                    if (swatchToSelect) {
                        swatchToSelect.classList.add('selected');
                    }
                }

                // Applica le modifiche necessarie
                if (swatchToSelect) {
                    const isAvailable = swatchToSelect.getAttribute('data-variant-available') === 'true';
                    const variantId = swatchToSelect.getAttribute('data-variant-id');
                    const variantImageUrl = swatchToSelect.getAttribute('data-variant-image');

                    // Aggiorna l'immagine
                    if (variantImageUrl) {
                        const productImage = card.querySelector('.product-card__media img');
                        if (productImage) {
                            productImage.src = variantImageUrl;

                            if (productImage.hasAttribute('srcset')) {
                                const width = productImage.width || 1080;
                                productImage.srcset = `${variantImageUrl} ${width}w`;
                            }
                        }
                    }

                    // Aggiorna l'ID della variante
                    if (variantId) {
                        const variantInput = card.querySelector('.selected-variant-id');
                        if (variantInput) {
                            variantInput.value = variantId;
                        }

                        // Aggiorna i link
                        updateProductLink(card, variantId);
                    }

                    // Aggiorna lo stato del bottone
                    updateButtonState(card, isAvailable);
                }

                // Segna la card come inizializzata
                state.initialized.add(card.dataset.swatchId);
                initializedCount++;
            });

        } finally {
            // Rilascia il flag di inizializzazione
            setTimeout(() => {
                state.initializing = false;
            }, 500);
        }
    }

    // Handler per il click sullo swatch
    // Handler per il click sullo swatch - VERSIONE UNIFICATA
    function handleSwatchClick(event) {
        event.preventDefault();

        // Controllo per evitare click multipli
        if (this.dataset.processing === 'true') return;
        this.dataset.processing = 'true';

        try {
            // Trova la card del prodotto - funziona sia per card che per drawer
            let productCard = this.closest('.product-card');

            // Se non trova la card (caso drawer), cerca tramite aria-controls
            if (!productCard) {
                const drawer = this.closest('[id*="Drawer"]');
                if (drawer) {
                    const drawerId = drawer.id;
                    const drawerButton = document.querySelector(`[aria-controls="${drawerId}"]`);
                    productCard = drawerButton ? drawerButton.closest('.product-card') : null;
                }
            } else {
            }

            if (!productCard) {
                return;
            }

            const variantId = this.getAttribute('data-variant-id');

            // Rimuovi la classe 'selected' da tutti gli swatch nella card
            productCard.querySelectorAll('[data-variant-swatch]').forEach(swatch => {
                swatch.classList.remove('selected');
            });

            // Seleziona lo swatch corrispondente nella card (per il caso drawer)
            productCard.querySelectorAll('[data-variant-swatch]').forEach(swatch => {
                const swatchVariantId = swatch.getAttribute('data-variant-id');
                if (swatchVariantId === variantId) {
                    swatch.classList.add('selected');
                }
            });

            // Se siamo in un drawer, aggiorna anche gli swatch del drawer
            const drawer = this.closest('[id*="Drawer"]');
            if (drawer) {
                drawer.querySelectorAll('[data-variant-swatch]').forEach(swatch => {
                    const swatchVariantId = swatch.getAttribute('data-variant-id');
                    if (swatchVariantId === variantId) {
                        swatch.classList.add('selected');
                    } else {
                        swatch.classList.remove('selected');
                    }
                });
            } else {
                // Se siamo nella card, sincronizza manualmente i drawer invece di chiamare syncDrawerSwatches
                const allDrawers = document.querySelectorAll('[id*="Drawer"]');
                allDrawers.forEach(drawerEl => {
                    if (!drawerEl.hasAttribute('hidden')) {
                        // Verifica se questo drawer appartiene a questa card
                        const drawerButton = document.querySelector(`[aria-controls="${drawerEl.id}"]`);
                        const drawerCard = drawerButton ? drawerButton.closest('.product-card') : null;

                        if (drawerCard === productCard) {
                            drawerEl.querySelectorAll('[data-variant-swatch]').forEach(drawerSwatch => {
                                const drawerVariantId = drawerSwatch.getAttribute('data-variant-id');
                                if (drawerVariantId === variantId) {
                                    drawerSwatch.classList.add('selected');
                                } else {
                                    drawerSwatch.classList.remove('selected');
                                }
                            });
                        }
                    }
                });
            }

            // Verifica disponibilità
            const isAvailable = this.getAttribute('data-variant-available') === 'true';

            // Aggiorna immagine
            const variantImageUrl = this.getAttribute('data-variant-image');
            if (variantImageUrl) {
                const productImage = productCard.querySelector('.product-card__media img');
                if (productImage) {
                    productImage.src = variantImageUrl;

                    if (productImage.hasAttribute('srcset')) {
                        const width = productImage.width || 1080;
                        productImage.srcset = `${variantImageUrl} ${width}w`;
                    }
                }
            }

            // Aggiorna ID variante
            if (variantId) {
                const variantInput = productCard.querySelector('.selected-variant-id, input[name="id"]');
                if (variantInput) {
                    variantInput.value = variantId;
                }

                // Aggiorna link
                updateProductLink(productCard, variantId);

                // Aggiorna bottone
                updateButtonState(productCard, isAvailable);
            }

            // Se siamo in un drawer, chiudilo dopo la selezione
            if (drawer) {
                setTimeout(() => {
                    const closeButton = drawer.querySelector('.drawer__close, [aria-controls="' + drawer.id + '"]');
                    if (closeButton) {
                        closeButton.click();
                    }
                }, 300);
            }

        } finally {
            // Rimuovi flag di elaborazione
            setTimeout(() => {
                this.dataset.processing = '';
            }, 200);
        }
    }

    // Funzione per aggiornare i link
    function updateProductLink(productCard, variantId) {
        productCard.querySelectorAll('a[data-product-card-link], .product-card__title').forEach(link => {
            const originalHref = link.getAttribute('href');
            if (!originalHref) return;

            if (!originalHref.includes('variant=')) {
                const separator = originalHref.includes('?') ? '&' : '?';
                link.setAttribute('href', `${originalHref}${separator}variant=${variantId}`);
            } else {
                const newHref = originalHref.replace(/variant=\d+/, `variant=${variantId}`);
                link.setAttribute('href', newHref);
            }
        });
    }

    // Funzione per aggiornare lo stato del bottone
    function updateButtonState(productCard, isAvailable) {
        const addToCartForm = productCard.querySelector('.add-to-cart-form');
        const soldOutButton = productCard.querySelector('.sold-out-button');

        if (!addToCartForm || !soldOutButton) return;

        if (isAvailable) {
            // Disponibile
            addToCartForm.style.display = '';
            addToCartForm.classList.remove('hidden');

            soldOutButton.style.display = 'none';
            soldOutButton.classList.add('hidden');

            const btnText = addToCartForm.querySelector('.quick-add-text');
            if (btnText && btnText.hasAttribute('data-original-label')) {
                btnText.textContent = btnText.getAttribute('data-original-label');
            }
        } else {
            // Non disponibile
            addToCartForm.style.display = 'none';
            addToCartForm.classList.add('hidden');

            soldOutButton.style.display = '';
            soldOutButton.classList.remove('hidden');
        }
    }

    // Funzione per rendere visibili tutte le card
    function makeAllProductCardsVisible() {
        document.querySelectorAll('.product-card').forEach(card => {
            card.style.visibility = 'visible';
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
        });

        document.querySelectorAll('motion-list').forEach(list => {
            list.style.visibility = 'visible';
            list.style.opacity = '1';

            Array.from(list.children).forEach(child => {
                child.style.visibility = 'visible';
                child.style.opacity = '1';
                child.style.transform = 'translateY(0)';
            });
        });
    }

    // INIZIO: Gestione specifica per product-recommendations
    function handleProductRecommendations() {
        // 1. Osserva gli elementi product-recommendations
        document.querySelectorAll('product-recommendations').forEach(recommendationsElement => {
            // Guarda se l'elemento ha già un observer
            if (recommendationsElement.dataset.swatchObserved === 'true') return;

            // Segna l'elemento come osservato
            recommendationsElement.dataset.swatchObserved = 'true';


            // Osserva le modifiche al DOM nell'elemento
            const observer = new MutationObserver(mutations => {
                let hasRelevantChanges = false;

                for (const mutation of mutations) {
                    // Verifica se sono stati aggiunti nodi
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        for (const node of mutation.addedNodes) {
                            // Verifica se è un nodo elemento
                            if (node.nodeType === 1) {
                                // Controlla se contiene card di prodotto
                                if (node.classList && (
                                    node.classList.contains('product-card') ||
                                    node.classList.contains('card-grid') ||
                                    node.querySelector('.product-card')
                                )) {
                                    hasRelevantChanges = true;
                                    break;
                                }
                            }
                        }
                    }

                    // Se abbiamo già trovato cambiamenti rilevanti, usciamo dal ciclo
                    if (hasRelevantChanges) break;
                }

                if (hasRelevantChanges) {

                    // Reset del contatore per consentire l'inizializzazione
                    state.initCounter = Math.max(0, state.initCounter - 3);

                    // Pianifica l'inizializzazione con un ritardo
                    setTimeout(() => {
                        makeAllProductCardsVisible();
                        initSwatchHandlers(true);
                    }, 800);
                }
            });

            // Avvia l'osservazione
            observer.observe(recommendationsElement, {
                childList: true,
                subtree: true
            });
        });

        // 2. Ascolta gli eventi custom relativi ai consigli
        document.addEventListener('recommendations:loaded', function() {

            // Reset del contatore
            state.initCounter = Math.max(0, state.initCounter - 3);

            // Pianifica l'inizializzazione
            setTimeout(() => {
                makeAllProductCardsVisible();
                initSwatchHandlers(true);
            }, 800);
        });
    }
    // FINE: Gestione specifica per product-recommendations

    // Funzione per gestire i tab
    function setupTabHandlers() {
        // Gestisci click sui tab
        document.addEventListener('click', function(event) {
            const tabButton = event.target.closest('[role="tab"], [is="api-hover-button"]');
            if (!tabButton) return;


            // Pulsante Promozioni
            if (tabButton.textContent.trim() === 'Promozioni') {
                // Trova l'ID del pannello target
                const targetId = tabButton.getAttribute('aria-controls');
                if (!targetId) return;

                // Pianifica un solo tentativo dopo un ritardo
                setTimeout(() => {
                    const panel = document.getElementById(targetId);
                    if (!panel || panel.hidden) return;

                    makeAllProductCardsVisible();

                    // Reset del contatore per permettere una nuova inizializzazione
                    state.initCounter = Math.max(0, state.initCounter - 3);
                    initSwatchHandlers(true);
                }, 800);
            }
        });

        // Osserva i cambiamenti negli attributi dei tab panel
        document.querySelectorAll('[id^="TabPanel-"]').forEach(panel => {
            new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.attributeName === 'hidden' && !panel.hidden) {

                        // Pianifica un solo tentativo
                        setTimeout(() => {
                            makeAllProductCardsVisible();
                            // Reset del contatore per permettere una nuova inizializzazione
                            state.initCounter = Math.max(0, state.initCounter - 3);
                            initSwatchHandlers(true);
                        }, 800);
                    }
                });
            }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
        });
    }

    // Funzione per gestire filtri e ordinamento
    function setupFilterHandlers() {
        // Evento pubsub
        if (window.theme && theme.pubsub) {
            theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, function() {

                // Reset del contatore per permettere una nuova inizializzazione
                state.initCounter = Math.max(0, state.initCounter - 3);

                // Pianifica un solo tentativo
                setTimeout(() => {
                    makeAllProductCardsVisible();
                    initSwatchHandlers(true);
                }, 800);
            });
        }

        // Click su filtri
        document.addEventListener('click', function(event) {
            const filterSelectors = [
                '.collection-filters__item',
                '.facets__item',
                '[data-filter-item]',
                '.sort-by__item'
            ];

            if (event.target.closest(filterSelectors.join(','))) {

                // Reset del contatore per permettere una nuova inizializzazione
                state.initCounter = Math.max(0, state.initCounter - 3);

                // Pianifica un solo tentativo
                setTimeout(() => {
                    makeAllProductCardsVisible();
                    initSwatchHandlers(true);
                }, 800);
            }
        });

        // Cambiamenti URL
        let lastUrl = location.href;
        setInterval(() => {
            const currentUrl = location.href;
            if (currentUrl !== lastUrl) {
                lastUrl = currentUrl;

                // Reset del contatore per permettere una nuova inizializzazione
                state.initCounter = Math.max(0, state.initCounter - 3);

                // Pianifica un solo tentativo
                setTimeout(() => {
                    makeAllProductCardsVisible();
                    initSwatchHandlers(true);
                }, 800);
            }
        }, 500);
    }

    // Funzione che monitora i nuovi elementi aggiunti al DOM
    function setupDynamicContentObserver() {
        // Osserva l'aggiunta di nuovi elementi al body
        const bodyObserver = new MutationObserver(mutations => {
            let needsInit = false;

            mutations.forEach(mutation => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    for (const node of mutation.addedNodes) {
                        if (node.nodeType !== 1) continue; // Solo elementi

                        // Verifica se l'elemento aggiunto è rilevante
                        if (
                            node.tagName === 'PRODUCT-RECOMMENDATIONS' ||
                            node.classList?.contains('product-card') ||
                            node.querySelector?.('product-recommendations, .product-card')
                        ) {
                            needsInit = true;

                            // Se troviamo product-recommendations, configuriamo gli observer specifici
                            if (node.tagName === 'PRODUCT-RECOMMENDATIONS' ||
                                node.querySelector?.('product-recommendations')) {
                                handleProductRecommendations();
                            }

                            break;
                        }
                    }
                }
            });

            if (needsInit) {

                // Reset del contatore
                state.initCounter = Math.max(0, state.initCounter - 3);

                // Pianifica un'inizializzazione
                setTimeout(() => {
                    makeAllProductCardsVisible();
                    initSwatchHandlers(true);
                }, 800);
            }
        });

        // Avvia l'osservazione sul body
        bodyObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

    }

    // Funzione di inizializzazione principale
    function initialize() {

        // Prima inizializzazione
        initSwatchHandlers();

        // Setup handler
        setupTabHandlers();
        setupFilterHandlers();
        handleProductRecommendations();
        setupDynamicContentObserver();

        // Reset del contatore dopo caricamento completo
        window.addEventListener('load', () => {
            state.initCounter = 0;

            // Pianifica un'inizializzazione dopo caricamento completo
            setTimeout(() => {
                makeAllProductCardsVisible();
                initSwatchHandlers(true);
            }, 1000);
        });

        // Controllo periodico per card non inizializzate
        /*
        const checkInterval = setInterval(() => {
            // Verifica se ci sono card con swatch ma senza selezione
            const uninitializedCards = Array.from(document.querySelectorAll('.product-card')).filter(card => {
                return card.querySelectorAll('[data-variant-swatch]').length > 0 &&
                    !card.querySelector('[data-variant-swatch].selected');
            });

            if (uninitializedCards.length > 0) {

                // Reset del contatore per permettere una nuova inizializzazione
                state.initCounter = Math.max(0, state.initCounter - 3);

                makeAllProductCardsVisible();
                initSwatchHandlers(true);
            }

            // Dopo 5 verifiche, riduci la frequenza dei controlli
            if (state.initCounter >= 5) {
                clearInterval(checkInterval);

                // Continua con un intervallo più lungo
                setInterval(() => {
                    const uninitializedCards = Array.from(document.querySelectorAll('.product-card')).filter(card => {
                        return card.querySelectorAll('[data-variant-swatch]').length > 0 &&
                            !card.querySelector('[data-variant-swatch].selected');
                    });

                    if (uninitializedCards.length > 0) {
                        state.initCounter = 0;
                        makeAllProductCardsVisible();
                        initSwatchHandlers(true);
                    }
                }, 5000);
            }
        }, 2000);

         */
    }

    // Avvia il tutto
    initialize();
})();


//gestione numero di telefono nella registrazione
// Funzione per estrarre parametri dall'URL
function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

// Funzione per gestire il campo telefono con il nuovo sistema
function handlePhoneFromUrl() {
    // Estrai il parametro phone dall'URL
    const phoneFromUrl = getUrlParameter('phone');

    // Trova i campi del nuovo sistema telefono
    const phoneField = document.getElementById('phone');
    const phonePrefixSelect = document.getElementById('phone-prefix');

    if (phoneField && phonePrefixSelect && phoneFromUrl) {
        // Se c'è un numero di telefono nell'URL, analizzalo per estrarre prefisso e numero
        const phoneNumber = phoneFromUrl;
        
        // Estrai il prefisso (primi caratteri dopo il +)
        const prefixMatch = phoneNumber.match(/^(\+\d{1,4})/);
        if (prefixMatch) {
            const prefix = prefixMatch[1];
            const number = phoneNumber.substring(prefix.length);
            
            // Imposta il prefisso selezionando l'opzione corrispondente
            const prefixOption = phonePrefixSelect.querySelector(`option[value="${prefix}"]`);
            if (prefixOption) {
                phonePrefixSelect.value = prefix;
            }
            
            // Imposta il numero senza prefisso
            phoneField.value = number;
        } else {
            // Se non c'è prefisso, usa solo il numero
            phoneField.value = phoneNumber;
        }
        
        // Rendi solo il campo telefono readonly, il prefisso rimane modificabile
        phoneField.readOnly = true;

        // Aggiungi classe CSS per lo styling solo al campo telefono
        phoneField.classList.add('readonly-field');

    } else if (phoneField && phonePrefixSelect) {
        // Se non c'è il numero nell'URL, assicurati che i campi siano modificabili
        phoneField.readOnly = false;
        phoneField.classList.remove('readonly-field');
    }
}

// Esegui la funzione quando la pagina è caricata
document.addEventListener('DOMContentLoaded', handlePhoneFromUrl);

//js pagina prodotto
// Stato globale per i filtri famiglia e selezioni
const familyFilterStates = new Map();
const selectedSwatchStates = new Map();
let listenersInitialized = false;

// Inizializzazione al caricamento del DOM
document.addEventListener('DOMContentLoaded', function() {
    initializeVariantPickers();
});

function initializeVariantPickers() {
    // Inizializza i listener solo una volta
    if (!listenersInitialized) {
        setupEventListeners();
        listenersInitialized = true;
    }

    // Inizializza gli stati dei variant picker esistenti
    const existingPickers = document.querySelectorAll('.variant-picker');
    existingPickers.forEach(picker => {
        setupInitialState(picker);
    });

    // Setup observer per nuovi elementi
    setupMutationObserver();
}

function setupEventListeners() {
    // Event delegation per le select dei colori
    document.addEventListener('change', function(event) {
        if (event.target.matches('[data-color-select]')) {
            handleColorSelectChange(event);
        }
    });

    // Event delegation per i filtri famiglia
    document.addEventListener('click', function(event) {
        if (event.target.matches('.family-filter-btn')) {
            event.preventDefault();
            handleFamilyFilterClick(event);
        }
    });

    // Event delegation per i radio buttons (swatch)
    document.addEventListener('change', function(event) {
        if (event.target.matches('input[type="radio"][name*="Color"], input[type="radio"][name*="Colour"]')) {
            handleSwatchChange(event);
        }
    });
}

function setupMutationObserver() {
    // Observer per intercettare i cambiamenti nel DOM (aggiornamenti AJAX)
    const observer = new MutationObserver(function(mutations) {
        let shouldRestore = false;

        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        // Se è stato aggiunto un variant picker o contiene un variant picker
                        if (node.classList && node.classList.contains('variant-picker') ||
                            node.querySelector && node.querySelector('.variant-picker')) {
                            shouldRestore = true;

                            // Applica immediatamente il filtro per evitare il flash
                            quickFilterApplication(node);
                        }
                    }
                });
            }
        });

        if (shouldRestore) {
            // Delay per il ripristino completo
            setTimeout(() => {
                restoreAllStates();
            }, 50);
        }
    });

    // Osserva i cambiamenti nel document
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

function quickFilterApplication(node) {
    // Trova tutti i variant picker nel nodo aggiunto
    const variantPickers = node.classList && node.classList.contains('variant-picker')
        ? [node]
        : Array.from(node.querySelectorAll ? node.querySelectorAll('.variant-picker') : []);

    variantPickers.forEach(picker => {
        const familyContainer = picker.querySelector('[data-family-filter-container]');
        if (!familyContainer) return;

        const productHandle = familyContainer.dataset.productHandle;
        const savedFamily = familyFilterStates.get(productHandle);

        if (savedFamily && savedFamily !== 'all') {
            // Applica immediatamente il filtro senza animazioni
            const swatchesContainer = picker.querySelector('[data-swatches-container]');
            if (swatchesContainer) {
                const swatchItems = swatchesContainer.querySelectorAll('.swatch-item');
                swatchItems.forEach(item => {
                    const itemFamily = item.dataset.family;
                    if (itemFamily !== savedFamily) {
                        item.style.display = 'none';
                    }
                });
            }
        }
    });
}

function handleColorSelectChange(event) {
    const selectedValue = event.target.value;
    const targetId = event.target.querySelector(`option[value="${selectedValue}"]`)?.dataset.targetId;

    if (targetId) {
        // Salva gli stati prima del cambio
        saveCurrentStates(event.target);

        // Trova il radio button corrispondente e triggeralo
        const targetRadio = document.getElementById(targetId);
        if (targetRadio) {
            targetRadio.click();
        }
    }
}

function handleFamilyFilterClick(event) {
    const container = event.target.closest('[data-family-filter-container]');
    if (!container) return;

    const productHandle = container.dataset.productHandle;
    const selectedFamily = event.target.dataset.family;

    // Salva lo stato del filtro
    familyFilterStates.set(productHandle, selectedFamily);

    // Forza l'aggiornamento per i click manuali
    applyFamilyFilter(container, selectedFamily, true);
}

function handleSwatchChange(event) {
    // Salva gli stati prima del cambio
    saveCurrentStates(event.target);

    // Salva anche quale swatch è stato selezionato
    const container = event.target.closest('.variant-input-wrapper');
    if (container) {
        const productHandle = container.querySelector('[data-family-filter-container]')?.dataset.productHandle;
        if (productHandle) {
            selectedSwatchStates.set(productHandle, {
                value: event.target.value,
                id: event.target.id
            });
        }
    }
}

function saveCurrentStates(element) {
    const container = element.closest('.variant-input-wrapper');
    if (!container) return;

    const familyContainer = container.querySelector('[data-family-filter-container]');
    if (!familyContainer) return;

    const productHandle = familyContainer.dataset.productHandle;

    // Salva filtro famiglia
    const activeButton = familyContainer.querySelector('.family-filter-btn.active');
    if (activeButton && productHandle) {
        const selectedFamily = activeButton.dataset.family;
        familyFilterStates.set(productHandle, selectedFamily);
    }

    // Salva swatch selezionato
    const checkedRadio = container.querySelector('input[type="radio"]:checked');
    if (checkedRadio && productHandle) {
        selectedSwatchStates.set(productHandle, {
            value: checkedRadio.value,
            id: checkedRadio.id
        });
    }
}

function applyFamilyFilter(container, selectedFamily, forceUpdate = false) {
    const filterButtons = container.querySelectorAll('.family-filter-btn');
    const swatchesContainer = container.closest('.variant-input-wrapper').querySelector('[data-swatches-container]');
    const colorSelect = container.closest('.variant-input-wrapper').querySelector('[data-color-select]');

    if (!swatchesContainer || !colorSelect) return;

    // Controlla se il filtro è già attivo per evitare il flash
    const currentActiveButton = container.querySelector('.family-filter-btn.active');
    const isAlreadyActive = currentActiveButton && currentActiveButton.dataset.family === selectedFamily;

    if (isAlreadyActive && !forceUpdate) {
        return; // Il filtro è già attivo, non fare nulla
    }

    const swatchItems = swatchesContainer.querySelectorAll('.swatch-item');
    const selectOptions = colorSelect.querySelectorAll('option[data-family]');

    // Rimuovi classe active da tutti i bottoni
    filterButtons.forEach(btn => btn.classList.remove('active'));

    // Aggiungi classe active al bottone selezionato
    const targetButton = container.querySelector(`[data-family="${selectedFamily}"]`);
    if (targetButton) {
        targetButton.classList.add('active');
    }

    // Mostra/nascondi swatch in base alla famiglia selezionata
    swatchItems.forEach(item => {
        const itemFamily = item.dataset.family;

        if (selectedFamily === 'all' || itemFamily === selectedFamily) {
            // Solo se non è già visibile
            if (item.style.display === 'none') {
                item.style.display = 'block';
            }
        } else {
            // Solo se non è già nascosto
            if (item.style.display !== 'none') {
                item.style.display = 'none';
            }
        }
    });

    // Mostra/nascondi opzioni nella select in base alla famiglia selezionata
    selectOptions.forEach(option => {
        const optionFamily = option.dataset.family;

        if (selectedFamily === 'all' || optionFamily === selectedFamily) {
            if (option.style.display === 'none') {
                option.style.display = 'block';
                option.disabled = false;
            }
        } else {
            if (option.style.display !== 'none') {
                option.style.display = 'none';
                option.disabled = true;
            }
        }
    });

    // Reset della select se l'opzione selezionata non è più visibile
    const currentSelectedOption = colorSelect.querySelector('option:checked, option[selected]');
    if (currentSelectedOption && currentSelectedOption.dataset.family &&
        selectedFamily !== 'all' && currentSelectedOption.dataset.family !== selectedFamily) {
        colorSelect.selectedIndex = 0;
    }
}

function restoreSelectedSwatch(container, productHandle) {
    const savedSwatch = selectedSwatchStates.get(productHandle);
    if (!savedSwatch) return;

    // Prova prima con l'ID salvato
    let targetRadio = document.getElementById(savedSwatch.id);

    // Se non trovato, cerca per valore
    if (!targetRadio) {
        targetRadio = container.querySelector(`input[type="radio"][value="${savedSwatch.value}"]`);
    }

    if (targetRadio && !targetRadio.checked) {
        // Forza la selezione senza triggare eventi
        targetRadio.checked = true;

        // Aggiorna anche la select se presente
        const colorSelect = container.querySelector('[data-color-select]');
        if (colorSelect) {
            colorSelect.value = savedSwatch.value;
        }
    }
}

function restoreAllStates() {
    // Ripristina tutti gli stati salvati
    familyFilterStates.forEach((selectedFamily, productHandle) => {
        const container = document.querySelector(`[data-family-filter-container][data-product-handle="${productHandle}"]`);
        if (container) {
            // Prima applica il filtro famiglia
            applyFamilyFilter(container, selectedFamily);

            // Poi ripristina lo swatch selezionato
            const variantContainer = container.closest('.variant-input-wrapper');
            if (variantContainer) {
                restoreSelectedSwatch(variantContainer, productHandle);
            }
        }
    });
}

function setupInitialState(picker) {
    // Sincronizza lo stato iniziale tra select e radio buttons
    const colorSelect = picker.querySelector('[data-color-select]');
    const checkedRadio = picker.querySelector('input[type="radio"]:checked');

    if (colorSelect && checkedRadio) {
        const value = checkedRadio.value;
        colorSelect.value = value;
    }

    // Ripristina gli stati se esistono
    const familyContainer = picker.querySelector('[data-family-filter-container]');
    if (familyContainer) {
        const productHandle = familyContainer.dataset.productHandle;

        // Ripristina filtro famiglia
        const savedFamily = familyFilterStates.get(productHandle);
        if (savedFamily) {
            applyFamilyFilter(familyContainer, savedFamily);
            restoreSelectedSwatch(picker, productHandle);
        }
    }
}

// JS custom per gestire il product counter con paginazione e risultati filtrati
document.addEventListener('page:loaded', () => {
    // Controlla che il sistema di eventi (pubsub) del tema sia disponibile.
    if (window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS.facetUpdate) {

        // Ci iscriviamo all'evento 'facetUpdate' che il tema emette dopo l'aggiornamento dei filtri.
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, (eventData) => {

            // Grazie al tuo debug, ora sappiamo che il nuovo HTML si trova nella proprietà 'responseText'.
            if (eventData && typeof eventData.responseText === 'string') {

                const newSectionHtml = eventData.responseText;

                // Usiamo DOMParser per trasformare la stringa di testo HTML in un "documento virtuale"
                // che possiamo analizzare per trovare gli elementi che ci servono.
                const parser = new DOMParser();
                const parsedHTML = parser.parseFromString(newSectionHtml, 'text/html');

                // 1. Trova l'elemento '.pagination-info' nel nuovo HTML ricevuto via AJAX.
                const newPaginationInfo = parsedHTML.querySelector('.pagination-info');

                // 2. Trova l'elemento '.pagination-info' attualmente visibile sulla pagina.
                const currentPaginationInfo = document.querySelector('.pagination-info');

                // 3. Se entrambi gli elementi sono stati trovati, sostituisci il contenuto del vecchio
                //    con il contenuto del nuovo. Questo aggiorna il testo a schermo.
                if (newPaginationInfo && currentPaginationInfo) {
                    currentPaginationInfo.innerHTML = newPaginationInfo.innerHTML;
                }
            }
        });
    }
});

/**
 * Sposta il pulsante "Quick Add" e gestisce il layout e il testo
 * in modo responsive tra mobile e desktop.
 * Versione finale completa.
 */
function setupResponsiveQuickAdd() {
    const mobileBreakpoint = window.matchMedia('(max-width: 767px)');
    const productCards = document.querySelectorAll('.product-card');

    // NUOVO: All'avvio, memorizziamo il testo originale (desktop) per ogni bottone.
    productCards.forEach(card => {
        const buttonTextSpan = card.querySelector('.quick-add button[type="submit"] .btn-text span[data-sold-out]');
        if (buttonTextSpan) {
            // Usiamo un data attribute per salvare il testo iniziale, es. "Aggiungi alla Shopping Bag"
            buttonTextSpan.dataset.desktopText = buttonTextSpan.textContent.trim();
        }
    });

    const handleLayoutChange = (event) => {
        productCards.forEach(card => {
            const quickAdd = card.querySelector('.quick-add');
            const mobileParent = card.querySelector('.product-card__content');
            const originalParent = card.querySelector('.product-card__media');

            // Selezioniamo il bottone e il suo contenitore di testo
            const submitButton = quickAdd?.querySelector('button[type="submit"]');
            const buttonTextSpan = submitButton?.querySelector('.btn-text span[data-sold-out]');

            if (!quickAdd || !mobileParent || !originalParent || !submitButton || !buttonTextSpan) {
                return; // Sicurezza per evitare errori
            }

            if (event.matches) {
                // SÌ, siamo su mobile:
                mobileParent.appendChild(quickAdd);
                quickAdd.classList.remove('absolute');

                // NUOVO: Cambia il testo del bottone con quello per mobile letto dal data attribute
                const mobileText = submitButton.dataset.quickAddText;
                if (mobileText) {
                    buttonTextSpan.textContent = mobileText;
                }

            } else {
                // NO, siamo su desktop:
                originalParent.appendChild(quickAdd);
                quickAdd.classList.add('absolute');

                // NUOVO: Ripristina il testo originale del bottone per desktop
                const desktopText = buttonTextSpan.dataset.desktopText;
                if (desktopText) {
                    buttonTextSpan.textContent = desktopText;
                }
            }
        });
    };

    handleLayoutChange(mobileBreakpoint);
    mobileBreakpoint.addEventListener('change', handleLayoutChange);
}

document.addEventListener('DOMContentLoaded', setupResponsiveQuickAdd);

// CUSTOMER ACCOUNT FUNCTIONALITY
document.addEventListener('DOMContentLoaded', function() {
    initializeAccountFunctionality();
});

function initializeAccountFunctionality() {
    // Gestione form account details
    const accountForm = document.querySelector('.account-details-form');
    if (accountForm) {
        accountForm.addEventListener('submit', handleAccountFormSubmit);
    }
    
    // Gestione navigation tra sezioni
    initializeSectionNavigation();
    
    // Gestione responsive navigation
    handleAccountNavResponsive();
}

function initializeSectionNavigation() {
    const sidebarLinks = document.querySelectorAll('.account-sidebar-link[data-section]');
    const sections = document.querySelectorAll('.account-section[data-section]');
    
    if (sidebarLinks.length === 0 || sections.length === 0) return;
    
    // Gestione click sui link sidebar
    sidebarLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetSection = this.getAttribute('data-section');
            
            // Rimuovi active da tutti i link
            sidebarLinks.forEach(l => l.classList.remove('active'));
            
            // Aggiungi active al link cliccato
            this.classList.add('active');
            
            // Nascondi tutte le sezioni
            sections.forEach(section => {
                section.style.display = 'none';
            });
            
            // Mostra la sezione target
            const targetSectionElement = document.getElementById(targetSection);
            if (targetSectionElement) {
                targetSectionElement.style.display = 'block';
            }
            
            // Aggiorna URL senza refresh
            history.pushState(null, null, `${this.href}`);
        });
    });
    
    // Controlla URL iniziale per mostrare sezione corretta
    checkInitialSection();
    
    // Gestione browser back/forward
    window.addEventListener('popstate', checkInitialSection);
}

function checkInitialSection() {
    const hash = window.location.hash.substring(1);
    const validSections = ['profilo', 'ordini'];
    
    let targetSection = 'profilo'; // Default
    
    if (validSections.includes(hash)) {
        targetSection = hash;
    }
    
    // Aggiorna UI
    const sidebarLinks = document.querySelectorAll('.account-sidebar-link[data-section]');
    const sections = document.querySelectorAll('.account-section[data-section]');
    
    // Rimuovi active da tutti i link
    sidebarLinks.forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('data-section') === targetSection) {
            link.classList.add('active');
        }
    });
    
    // Mostra/nascondi sezioni
    sections.forEach(section => {
        const sectionType = section.getAttribute('data-section');
        if (sectionType === targetSection) {
            section.style.display = 'block';
        } else {
            section.style.display = 'none';
        }
    });
}

function handleAccountFormSubmit(e) {
    e.preventDefault();
    
    const form = e.target;
    const submitBtn = form.querySelector('.account-submit-btn');
    const originalText = submitBtn.textContent;
    
    // Mostra stato di caricamento
    submitBtn.textContent = 'Aggiornamento in corso...';
    submitBtn.disabled = true;
    
    // Simula invio form (puoi sostituire con la logica reale)
    setTimeout(() => {
        // Qui andresti a fare la chiamata AJAX reale a Shopify
        // Per ora mostriamo solo un messaggio di successo
        
        submitBtn.textContent = '✓ Aggiornato!';
        submitBtn.style.backgroundColor = '#28a745';
        
        setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
            submitBtn.style.backgroundColor = '';
        }, 2000);
        
        // Mostra messaggio di successo
        showAccountMessage('Dati aggiornati con successo!', 'success');
        
    }, 1500);
}

function showAccountMessage(message, type = 'info') {
    // Rimuovi messaggi esistenti
    const existingMessage = document.querySelector('.account-message');
    if (existingMessage) {
        existingMessage.remove();
    }
    
    // Crea nuovo messaggio
    const messageDiv = document.createElement('div');
    messageDiv.className = `account-message account-message--${type}`;
    messageDiv.innerHTML = `
        <span>${message}</span>
        <button type="button" class="account-message-close">&times;</button>
    `;
    
    // Aggiungi stili inline per il messaggio
    messageDiv.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${type === 'success' ? '#28a745' : type === 'error' ? '#dc3545' : '#17a2b8'};
        color: white;
        padding: 15px 20px;
        border-radius: 5px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 9999;
        display: flex;
        align-items: center;
        gap: 15px;
        animation: slideInRight 0.3s ease;
        max-width: 400px;
        font-size: 14px;
        font-weight: 500;
    `;
    
    // Aggiungi al body
    document.body.appendChild(messageDiv);
    
    // Gestione chiusura
    const closeBtn = messageDiv.querySelector('.account-message-close');
    closeBtn.style.cssText = `
        background: none;
        border: none;
        color: white;
        font-size: 20px;
        cursor: pointer;
        padding: 0;
        line-height: 1;
    `;
    
    closeBtn.addEventListener('click', () => {
        messageDiv.remove();
    });
    
    // Auto rimozione dopo 5 secondi
    setTimeout(() => {
        if (messageDiv.parentNode) {
            messageDiv.remove();
        }
    }, 5000);
    
    // Aggiungi CSS animazione se non esiste
    if (!document.querySelector('#account-message-styles')) {
        const styles = document.createElement('style');
        styles.id = 'account-message-styles';
        styles.textContent = `
            @keyframes slideInRight {
                from { transform: translateX(100%); opacity: 0; }
                to { transform: translateX(0); opacity: 1; }
            }
        `;
        document.head.appendChild(styles);
    }
}

// Gestione responsive per la sidebar account su mobile
function handleAccountNavResponsive() {
    const accountSidebar = document.querySelector('.account-sidebar-nav');
    if (!accountSidebar) return;
    
    // Aggiungi scroll orizzontale touch-friendly su mobile (solo sotto 1024px)
    function setupTouchScroll() {
        if (window.innerWidth <= 1024) {
            let isDown = false;
            let startX;
            let scrollLeft;
            
            accountSidebar.addEventListener('mousedown', (e) => {
                isDown = true;
                startX = e.pageX - accountSidebar.offsetLeft;
                scrollLeft = accountSidebar.scrollLeft;
            });
            
            accountSidebar.addEventListener('mouseleave', () => {
                isDown = false;
            });
            
            accountSidebar.addEventListener('mouseup', () => {
                isDown = false;
            });
            
            accountSidebar.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - accountSidebar.offsetLeft;
                const walk = (x - startX) * 2;
                accountSidebar.scrollLeft = scrollLeft - walk;
            });
        }
    }
    
    setupTouchScroll();
    
    // Re-setup on window resize
    window.addEventListener('resize', setupTouchScroll);
}
// END CUSTOMER ACCOUNT FUNCTIONALITY


